module.exports = __webpack_public_path__ + "img/demo-screencast.849ed24e.gif";